export const gridColIdLocalStorage = {
  contract: "grid_col_contract",
  booking: "grid_col_booking",
  task: "grid_col_task",
  shipment: "grid_col_shipment",
  import_contract: "grid_col_import_contract",
  import_booking: "grid_col_import_booking",
  import_shipment: "grid_col_import_shipment",
} as const;
